import { Link } from "react-router-dom";

const anchors = [
  { href: "#buch", label: "Das Buch", id: "buch" },
  { href: "#autor", label: "Über den Autor", id: "autor" },
  { href: "#bestellen", label: "Bestellen", id: "bestellen" },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/5 bg-navy-950 py-14"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="font-display font-extrabold text-lg text-white">
            Blaulicht<span className="text-blau">Praxis</span>
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Datenschutz in der Blaulichtfamilie
          </p>
        </div>

        <nav aria-label="Footernavigation" className="flex flex-wrap gap-x-8 gap-y-3">
          {anchors.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`footer-link-${l.id}`}
              className="text-sm text-gray-400 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/impressum"
            data-testid="footer-link-impressum"
            className="text-sm text-gray-400 transition-colors duration-200 hover:text-white"
          >
            Impressum
          </Link>
          <Link
            to="/datenschutz"
            data-testid="footer-link-datenschutz"
            className="text-sm text-gray-400 transition-colors duration-200 hover:text-white"
          >
            Datenschutz
          </Link>
        </nav>
      </div>

      <div className="mt-12 border-t border-white/5 pt-8">
        <p className="text-xs text-gray-600">© Jörg Eisbach / BlaulichtPraxis</p>
      </div>
    </div>
  </footer>
);

export default Footer;
